import React from "react"
import FieldProto_FormElement from "../../../../proto/render/form-element"
// @ts-ignore
import FieldRenderEditableInlineTextarea from "../inline-editable/textarea-editable-inline"

export default class FieldText_FormElement extends FieldProto_FormElement {
    render() {
        return <FieldRenderEditableInlineTextarea viewClasses       = {Classes("ui5-txt-default ui5-field-form-editable min-h-36 p-l-10 p-r-10 p-t-7 p-b-7", this.props.className)}
                                                  editClasses       = {Classes("ui5-txt-default ui5-field-form-editable min-h-36 p-l-10 p-r-10 p-t-7 p-b-7", this.props.className)}
                                                  rows              = {this.props.rows}
                                                  field             = {this.props.field}
                                                  value             = {this.value}
                                                  disabled          = {this.props.disabled}
                                                  onImmediateChange = {this.onChange}/>

    }
}